import { Injectable } from '@angular/core';
import { reject } from 'lodash';
import { environment } from '../../environments/environment';
import { LoadScriptService } from './load-script.service';

/**
 * Please notice that google recaptcha is loaded in the index.html, if we do not load it in the index then
 * we need to use the LoadScript service here.
 */
@Injectable({providedIn: 'root'})
export class CaptchaService {

  readonly CAPTCHA_SITE_KEY = environment.CAPTCHA_SITE_KEY;

  constructor(private loadScriptService: LoadScriptService) {
  }

  async getCaptchaToken(action: string): Promise<string> {
    await this.ensureCaptchaReady();
    // @ts-ignore
    return window.grecaptcha.enterprise.execute(this.CAPTCHA_SITE_KEY, {action: action});
  }

  async hideCaptchaBanner(): Promise<void> {
    await this.ensureCaptchaReady();
    const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
    if (badge) {
      badge.style.visibility = 'hidden';
    }
  }

  async showCaptchaBanner(): Promise<void> {
    await this.ensureCaptchaReady();
    const badge = document.querySelector('.grecaptcha-badge') as HTMLElement;
    if (badge) {
      badge.style.visibility = 'visible';
    }
  }

  private async ensureCaptchaReady(): Promise<void> {
    await this.loadScriptService.loadScript(LoadScriptService.GOOGLE_CAPTCHA);
    return new Promise((resolve) => {
      let tries = 0;
      const interval = setInterval(() => {
        // @ts-ignore
        if (window.grecaptcha && window.grecaptcha.enterprise && typeof window.grecaptcha.enterprise.execute === 'function') {
          clearInterval(interval);
          resolve();
        } else if (++tries > 100) {
          clearInterval(interval);
          reject(new Error('grecaptcha.enterprise not available after waiting'));
        }
      }, 50);
    });
  }
}
